import React from 'react'

import './index.scss'
import {SpinnerIco} from "../../../modules/CustomIcons";
import {Spin} from "antd";


const FullScreenLoading: React.FC = (props : any) => {
  return (
      <div className="fullScreenLoading flex align_center justify_center">

          <Spin indicator={<SpinnerIco />} />

      </div>
  )
}

export default FullScreenLoading
